import request from '@/utils/request'
import axios from 'axios'


// 查询所有商户（包含子商户）
export function queryShopForLineUnder(data){
  return request({ url: '/shop/affiliated/info/list', method: 'post', data })
}

// 查询所有商户（包含子商户）
export function queryAllShop(data){
  return request({ url: '/shop/queryAllShopList', method: 'post', data })
}
//商户列表 ( 不含主商户 )
export function sellerQuery(data) {
  return request({ url: '/shop/audit/queryShopList', method: 'post', data })
}
//商户详情
export function sellerDetailQuery(data) {
  return request({ url: '/shop/detail', method: 'post', data })
}
//商户详情
export function sellerUpdate(data) {
  return request({ url: '/shop/update', method: 'post', data })
}
//子商户列表查询
export function sellerSubordinateList(data) {
  return request({ url: '/shop/subShop/queryList', method: 'post', data })
}
//子商户禁用
export function sellerSubordinateForbidden(data) {
  return request({ url: '/shop/subShop/forbidden', method: 'post', data })
}
//子商户启用
export function sellerSubordinateEnable(data) {
  return request({ url: '/shop/subShop/unForbidden', method: 'post', data })
}
//子商户新增
export function sellerAddSubordinate(data) {
  return request({ url: '/shop/subShop/createSubShop', method: 'post', data })
}
//子商户更新
export function sellerUpdateSubordinate(data) {
  return request({ url: '/shop/subShop/updateSubShop', method: 'post', data })
}
//子商户查看详情
export function sellerSubordinateDetail(data) {
  return request({ url: '/shop/subShop/detailById', method: 'post', data })
}
//子商户绑定商户卡
export function sellerSubordinateBind(data) {
  return request({ url: '/shop/subShop/bindShopCard', method: 'post', data })
}
//子商户解绑商户卡
export function sellerSubordinateUnBind(data) {
  return request({ url: '/shop/subShop/unBindShopCard', method: 'post', data })
}
//商户关系列表查询
export function sellerRelationList(data) {
  return request({ url: '/shop/subShop/queryShopRelList', method: 'post', data })
}
//商户关系禁用
export function sellerRelationForbidden(data) {
  return request({ url: '/shop/subShop/forbiddenShopRel', method: 'post', data })
}
//商户关系启用
export function sellerRelationEnable(data) {
  return request({ url: '/shop/subShop/unForbiddenShopRel', method: 'post', data })
}
//所有子商户和主商户名称和ID查询
export function sellerAllNameList(data) {
  return request({ url: '/shop/subShop/queryNameList', method: 'post', data })
}
//添加商户关系
export function sellerAddRelation(data) {
  return request({ url: '/shop/subShop/relateParentShop', method: 'post', data })
}
//修改商户关系
export function sellerUpdateRelation(data) {
  return request({ url: '/shop/subShop/updateRelatedShop', method: 'post', data })
}
//商户关系详情
export function sellerRelationDetail(data) {
  return request({ url: '/shop/queryShopRelDetail', method: 'post', data })
}
//商户新增
export function sellerAdd(data) {
  return request({ url: '/shop/create', method: 'post', data })
}
//商户修改
export function sellerEdit(data) {
  return request({ url: '/shop/update', method: 'post', data })
}
//商户禁用
export function shopForbidden(data) {
  return request({ url: '/shop/forbidden', method: 'post', data })
}
//商户启用
export function shopEnable(data) {
  return request({ url: '/shop/enable', method: 'post', data })
}
//商户卡解绑
export function unBindShopCard(data) {
  return request({ url: '/shop/subShop/unBindShopCard', method: 'post', data })
}
//商户卡解绑
export function bindShopCard(data) {
  return request({ url: '/shop/subShop/bindShopCard', method: 'post', data })
}
//商户卡读卡
export function getCardNum(data) {
  return axios.get('http://127.0.0.1:9000/getCardNum')
    .then(function (response) {
      return response
    })
  // return request({ url: '/cardService/getCardNum', method: 'post', data })
}
//商户审核列表
export function sellerApproveQuery(data) {
  return request({ url: '/shop/audit/list', method: 'post', data })
}
//商户审核详情
export function sellerApproveDetail(data) {
  return request({ url: '/shop/queryShopAuditDetail', method: 'post', data })
}
//商户审批通过
export function sellerApprovePass(data) {
  return request({ url: '/shop/approved', method: 'post', data })
}
//商户补录审批通过
export function sellerReplenishPass(data) {
  return request({ url: '/shop/additional/approved', method: 'post', data })
}
//商户审批不通过
export function sellerApproveReject(data) {
  return request({ url: '/shop/rejected', method: 'post', data })
}
//子商户审批不通过
export function subShopApproveReject(data) {
  return request({ url: '/shop/subShop/reject', method: 'post', data })
}
//子商户审批通过
export function subShopApprovePass(data) {
  return request({ url: '/shop/subShop/approved', method: 'post', data })
}
//查询商户三级分类
export function sellerAllCategory(data) {
  return request({ url: '/product/category/shop/list', method: 'post', data })
}
// 查询采小助分类列表
export function purchaseCateList(data) {
  return request({ url: '/purchase/category/shop/list', method: 'post', data })
}

//查询绑定详情
export function queryShopRelAuditDetail(data) {
  return request({ url: '/shop/queryShopRelAuditDetail', method: 'post', data })
}
//查询支付方式
export function querySwitchSingle(data) {
  return request({ url: '/shop/arrival/switch/single', method: 'post', data })
}
//更改支付方式
export function SwitchSingleDeal(data) {
  return request({ url: '/shop/arrivalPay/switch/deal', method: 'post', data })
}
//获取商户评价
export function getStarts(data) {
  return request({ url: '/shop/star/level/detail', method: 'post', data })
}
//更新商户评价
export function updateStarts(data) {
  return request({ url: '/shop/star/level/update', method: 'post', data })
}

//费率权限查看审批详情
export function queryShopRateDetail(data) {
  return request({ url: '/shop/queryShopRateAuditDetail', method: 'post', data })
}
//费率权限审核驳回
export function dealRateRejected(data) {
  return request({ url: '/shop/rateRejected', method: 'post', data })
}




//ICBC
export function ICBCdeal(data) {
  return request({ url: '/shop/icbc/switch/deal', method: 'post', data })
}



/**
 * 银行卡校验
 * @param data
 */
export function bankCardVerify(data) {
  return request({ url: '/shop/cardVerify', method: 'post', data })
}

/**
 * 身份证校验
 * @param data  {"idCard":"身份证号码","realName":"姓名"}
 */
export function idCardVerify(data) {
  return request({ url: '/member/idVerify', method: 'post', data })
}

// 查询主商户是否支持物流
export function freightSwitchList(data) {
  return request({ url: '/shop/freight/switch/list', method: 'post', data })
}
// 关闭物流
export function freightSwitchOff(data) {
  return request({ url: '/shop/freight/switch/off', method: 'post', data })
}
// 开启物流
export function freightSwitchOn(data) {
  return request({ url: '/shop/freight/switch/on', method: 'post', data })
}
// 获取商铺二维码
export function getShopQrcode(data) {
  return request({ url: '/shop/qrcode', method: 'post', data })
}

//不带权限 查询所有商户
export function getAllShopList(data) {
  return request({ url: '/shop/audit/queryNewShopList', method: 'post', data })
}
//直接收银设置
export function dealPay(data) {
  return request({ url: '/shop/directPay/switch/deal', method: 'post', data })
}
//库存同步开关设置
export function inventorySyncSwitch(data) {
  return request({ url: '/shop/inventorySync/switch', method: 'post', data })
}
//支持部分商品开启同步
export function partialSyncSwitch(data) {
  return request({ url: '/shop/partialSync/switch', method: 'post', data })
}


//主商户导出    return request({ url: '/paymentExport/charge', method: 'post', data, responseType: 'arraybuffer' })
export function exportShopList(data) {
  return request({ url: '/shop/audit/shopList/export', method: 'post', data, responseType: 'arraybuffer' })
}
// 费率审批通过
export function rateApprove(data) {
  return request({ url: '/shop/rateApproved', method: 'post', data })
}

//欠款管理
export function getdebtList(data) {
  return request({ url: '/debt/queryDebtedShopList', method: 'post', data })
}
//欠款管理详情
export function getdebtDetail(data) {
  return request({ url: '/debt/queryDebtedShopDetail', method: 'post', data })
}
//欠款订单管理
export function getdebtOrderList(data) {
  return request({ url: '/debt/queryPaybackBillList', method: 'post', data })
}
//欠款订单管理导出
export function exportdebtOrderList(data) {
  return request({ url: '/debt/exportPaybackBillList', method: 'post', data, responseType: 'arraybuffer' })
}
//欠款订单管理详情
export function getdebtOrderDetail(data) {
  return request({ url: '/debt/queryPaybackBillDetail', method: 'post', data })
}

//欠款客户详情
export function getCustomDetail(data) {
  return request({ url: '/debt/getDebtRelDetail', method: 'post', data })
}


//补打权限 修改
export function updatePrintSwitch(data) {
  return request({ url: '/shop/reprint/switch/update ', method: 'post', data })
}
//设置标签
export function addShopTag(data) {
  return request({ url: '/shop/addShopTag ', method: 'post', data })
}
//查询商户已有标签
export function queryShopTagData(data) {
  return request({ url: '/shop/queryShopTag', method: 'post', data })
}

// 商户会员卡管理 列表
export function getRelList(data) {
  return request({ url: '/shopMemberRel/list', method: 'post', data })
}
// 商户会员卡   绑定
export function shopAddRel(data) {
  return request({ url: '/shopMemberRel/addRel', method: 'post', data })
}
// 获取商户已绑定列表
export function getIsBindList(data) {
  return request({ url: '/shopMemberRel/relList', method: 'post', data })
}
// 商户会员解绑
export function unbindRel(data) {
  return request({ url: '/shopMemberRel/delRel', method: 'post', data })
}
// 商户会员卡导入
export function importMemberData(data) {
  return request({ url: '/shopMemberRel/importShopMemberRel ', method: 'post', data })
}
//绑定物业   所有物业账号查询
export function queryPropertyList(data) {
  return request({ url: '/shop/queryYzwyShopList', method: 'post', data })
}
//绑定物业   绑定
export function bindProperty(data) {
  return request({ url: '/shop/doBindingForYzwy', method: 'post', data })
}
//绑定物业   解绑
export function unbindProperty(data) {
  return request({ url: '/shop/doUnbindForYzwy', method: 'post', data })
}
// 是否可以上架商品 修改
export function updateListSwitch(data) {
  return request({ url: '/shop/switch/updateListSwitch', method: 'post', data })
}
// 是否可以申请开票
export function changeInvoiceSwitch(data) {
  return request({ url: '/shop/switch/updateInvoiceSwitch', method: 'post', data })
}
//商品审核开关
export function proReviewSwitch(data) {
  return request({ url: '/shop/updateExemptReviewByShopId', method: 'post', data })
}
// 修改按商品维度发货开关
export function updateSendProductSwitch(data) {
  return request({ url: '/shop/switch/updateSendProductSwitchByShopId', method: 'post', data })
}
// 修改按商品维度发货时是否强制校验标签是否打印开关
export function updateForcePrintLabelSwitch(data) {
  return request({ url: '/shop/switch/updateForcePrintLabelSwitchByShopId', method: 'post', data })
}
// 修改提现免审核标识
export function updateWithdrawAuditExemptSwitch(data) {
  return request({ url: '/shop/switch/updateWithdrawAuditExemptSwitchByShopId', method: 'post', data })
}




// WEBPACK FOOTER //
// ./src/api/seller.js